import React, { useState, useEffect } from "react";

const Countdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = targetDate - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),  // Corrected multiplication
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),  // Corrected multiplication
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div style={{ textAlign: "center" }}>
      {/* <h2>Hurry! Early sign-ups close in</h2> */}
      <ul>
                                <li><h5>{timeLeft.days}</h5><p>DAYS</p></li>
                                <li><h5>{timeLeft.hours}</h5><p>HOURS</p></li>
                                <li><h5>{timeLeft.minutes}</h5><p>MINUTES</p></li>
                                <li><h5>{timeLeft.seconds}</h5><p>SECONDS</p></li>
                            </ul>
      {/* <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
        <div>
          <h3>{timeLeft.days}</h3>
          <p>Days</p>
        </div>
        <div>
          <h3>{timeLeft.hours}</h3>
          <p>Hours</p>
        </div>
        <div>
          <h3>{timeLeft.minutes}</h3>
          <p>Minutes</p>
        </div>
        <div>
          <h3>{timeLeft.seconds}</h3>
          <p>Seconds</p>
        </div>
      </div> */}
    </div>
  );
};

export default Countdown;
